import Storage from "./Storage";
import Config from "../config";

export default function useBatchNo() {
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return { batchNo };
}
